import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-4" data-id="element-182">
            No es un PDF. Es esto:
          </h2>
          <p className="text-[#4A5568] text-lg" data-id="element-183">
            Es la tranquilidad de saber que estás construyendo el futuro de tu
            hijo sobre bases sólidas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
          {['Más confianza en sí mismo desde el día 3', 'Menos tensión y peleas a la hora de la tarea', 'Más disposición a intentar cosas nuevas', 'La seguridad de estar haciendo lo correcto como mamá'].map((item, index) => <div key={index} className="flex items-center p-6 bg-[#F5F1EA] rounded-xl border border-[#5C6B60]/10" data-id="element-185">
              <CheckCircle2 className="w-6 h-6 text-[#5C6B60] mr-4 flex-shrink-0" data-id="element-186" />
              <span className="text-[#2D3648] font-medium text-lg" data-id="element-187">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}